import { motion } from 'framer-motion';

interface GalleryImageProps {
  url: string;
  caption?: string;
  onClick: () => void;
}

export const GalleryImage = ({ url, caption, onClick }: GalleryImageProps) => (
  <motion.div
    className="relative group/image cursor-pointer rounded-lg overflow-hidden flex-shrink-0"
    whileHover={{ scale: 1.02 }}
    onClick={onClick}
    style={{ width: '500px' }}
  >
    <img
      src={url}
      alt={caption || 'Project image'}
      className="w-full aspect-video object-contain rounded-lg"
      loading="lazy"
    />
    <div
      className="absolute inset-0 bg-black/50 opacity-0 group-hover/image:opacity-100 
                    transition-opacity duration-300 flex flex-col items-center justify-center"
    >
      <span className="text-white text-sm font-medium mb-2">
        Click to enlarge
      </span>
      {caption && (
        <p className="text-white text-sm px-4 text-center">{caption}</p>
      )}
    </div>
  </motion.div>
);
